module.exports = __webpack_public_path__ + "static/media/builtinv2-POL protyjka.8b1d5b2e.png";